import { useTaal } from "@/contexts/TaalContext";
import { PROVIDERS } from "@/lib/providers";
import { gegroepeerd } from "@/lib/aanbieder-locatie";

/**
 * ZL4: het modeladvies per taak in de Postbus. Opdracht Frank, 27 oktober 2026.
 *
 * **ALLEEN EEN ADVIES.** Deze kaart heeft geen knop die een model of aanbieder kiest;
 * wisselen doet Frank zelf in Instellingen. Een wachter eist dat er hier geen
 * schrijfweg bij komt.
 *
 * **DE PLEK KOMT UIT DE ENE TABEL** (`lib/aanbieder-locatie.js`). De backend zegt welke
 * taak en welk model; welke aanbieder waar draait, staat alleen daar.
 */
export function mogelijkheden(aanbieders = PROVIDERS) {
  return gegroepeerd(aanbieders).map((g) => ({
    plek: g.plek,
    tekst: g.tekst,
    namen: g.items.map(([, p]) => p.name),
  }));
}

const procent = (x) => `${Math.round((x || 0) * 100)}%`;

export default function ModelAdvies({ advies }) {
  const { t } = useTaal();
  const scores = (advies.scores || []).map(procent).join(", ");
  return (
    <section className="space-y-2 text-sm" data-testid="modeladvies">
      <p data-testid="modeladvies-uitslag">
        {t("Het lokale model {model} haalde bij {taak} de laatste weken {scores} van de feiten, onder de grens van {grens}.", {
          model: advies.model, taak: t(advies.taak), scores, grens: procent(advies.drempel),
        })}
      </p>
      <p>
        {t("Voor deze taak is een ander model nodig. NovaMund heeft alleen het lokale model gemeten, dus welk ander model het wel kan, staat nog niet vast. Dit zijn de mogelijkheden, met waar ze draaien:")}
      </p>
      <ul className="space-y-1" data-testid="modeladvies-plekken">
        {mogelijkheden().map((g) => (
          <li key={g.plek} data-testid="modeladvies-plek">
            <span className="font-medium">{t(g.tekst)}</span>
            <span className="text-[hsl(var(--muted-foreground))]">: {g.namen.join(", ")}</span>
          </li>
        ))}
      </ul>
      <p className="text-xs text-[hsl(var(--muted-foreground))]">
        {t("NovaMund wisselt niet vanzelf van model. Kiezen doe je zelf in Instellingen.")}
      </p>
    </section>
  );
}
